import { MapPin } from 'lucide-react';

export function MapBanner() {
  return (
    <div
      className="relative h-[180px] bg-cover bg-center"
      style={{
        backgroundImage: 'url(/images/tops_background.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center center'
      }}
    >
      {/* Softer gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/50" />

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center pt-4">
        {/* Logo */}
        <div className="bg-white/95 backdrop-blur-sm rounded-xl p-3 shadow-lg mb-4">
          <img
            src="/images/TopsLogoCrop.png"
            alt="Tops Supermarket"
            className="h-16"
          />
        </div>

        {/* Address with icon */}
        <div className="flex items-center gap-2 text-white/90 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2">
          <MapPin className="w-4 h-4" />
          <span className="font-medium">1623 Centre St NW, Calgary, AB</span>
        </div>
      </div>
    </div>
  );
}
